import { Injectable      } from '@angular/core';
import { UtilsManager    } from 'src/app/managers/utils/utils.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier        } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RequestManager  } from 'src/app/managers/request/request.manager';
import { ErrorManager    } from 'src/app/managers/error/error.manager';

@Injectable({
  providedIn: 'root'
})
export class LicenceHandler
{
  constructor(
    private _utils    : UtilsManager    ,
    private _notifier : NotifierManager ,
    private _request  : RequestManager  ,
    private _error    : ErrorManager
  ) { }

  async list(token: string, siteId: number)
  {      
    try
    {
      const response = await this._request.licence().list( token, siteId ).toPromise()

      if (this._error.hasError(response)){
        // MANAGE ERROR
        return this._error.handleCQWebapp ( response ) 
      }

      return ( response as any ).response
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }

  async activate(token: string, deviceId: number)
  {      
    try
    {
      const response = await this._request.licence().activate( token, deviceId ).toPromise()

      if (this._error.hasError(response)){
        // MANAGE ERROR
        return this._error.handleCQWebapp ( response ) 
      }

      this._notifier.show(
        Notifier.SUCCESS                  , 
        NotifierMessage.OPERATION_OK 
      )

      return ( response as any )
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }

  async deactivate(token: string, deviceId: number)
  {      
    try
    {
      const response = await this._request.licence().deactivate( token, deviceId ).toPromise()

      if (this._error.hasError(response)){
        // MANAGE ERROR
        return this._error.handleCQWebapp ( response ) 
      }

      this._notifier.show(
        Notifier.SUCCESS                  , 
        NotifierMessage.OPERATION_OK 
      )

      return ( response as any )
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }

  async getToken(token: string, deviceId: number)
  {      
    try
    {
      const response = await this._request.licence().getToken( token, deviceId ).toPromise()

      if (this._error.hasError(response)){
        // MANAGE ERROR
        return this._error.handleCQWebapp ( response ) 
      }

      this._notifier.show(
        Notifier.SUCCESS                  , 
        NotifierMessage.OPERATION_OK 
      )

      return ( response as any ).response
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }

  async activateAll(token: string, siteId: number)
  {      
    try
    {
      const response = await this._request.licence().activateAll( token, siteId ).toPromise()

      if (this._error.hasError(response)){
        // MANAGE ERROR
        return this._error.handleCQWebapp ( response ) 
      }

      return ( response as any )
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }

  async extractExcel(token: string, siteId: number)
  {      
    try
    {
      return await this._request.licence().extractExcel( token, siteId ).toPromise()
    }catch(error)
    {
      // this._error.handleNetwork ( error )  
      return undefined
    }
  }
}

